import type { Portfolio } from "~/typings/portfolio";

export function extractAvailableTags(
  experiences: Portfolio.Experience[]
): string[] {
  const tagsSet = new Set<string>();

  experiences.forEach((experience) => {
    experience.projectTags?.forEach((tag) => tagsSet.add(tag));
  });

  return Array.from(tagsSet).sort();
}

export function countProjectsPerTag(
  experiences: Portfolio.Experience[]
): Record<string, number> {
  const count: Record<string, number> = {};

  experiences.forEach((experience) => {
    experience.projectTags?.forEach((tag) => {
      count[tag] = (count[tag] || 0) + 1;
    });
  });

  return count;
}

export function toggleTagSelection(
  selectedTags: string[],
  tag: string
): string[] {
  if (selectedTags.includes(tag)) {
    return selectedTags.filter((selectedTag) => selectedTag !== tag);
  }

  return [...selectedTags, tag];
}

export function filterExperiencesByTags(
  sortedExperiences: Portfolio.Experience[],
  activeTag: string | "all"
): Portfolio.Experience[] {
  if (activeTag === "all") {
    return sortedExperiences;
  }

  return sortedExperiences.filter((experience) =>
    experience.projectTags?.includes(activeTag)
  );
}
